// @ vendors
const get = require('lodash/object/get');
// @ commons
const { APIGet } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');
// @ constants
const actionTypes = require('constants/actionTypes');
// @ utilities
const { getAccountByImposition } = require('utilities/currentAccountsHelper.js');

const requestLiquidationsPeriodInProgress = () => ({
    type: actionTypes.FETCH_LIQUIDATIONS_PERIOD_REQUEST
});

const requestLiquidationsPeriodSuccess = (response) => ({
    type: actionTypes.FETCH_LIQUIDATIONS_PERIOD_SUCCESS,
    payload : {
        description: get(response, 'listaPeriodoLiquidacion.lista[1].descripcion', '')
    }
});

const requestLiquidationsPeriodFailure = (error) => ({
    type: actionTypes.FETCH_LIQUIDATIONS_PERIOD_FAILURE,
    payload : {
        error
    }
});

const requestLiquidationPeriods = (depositId, impositionId) => (dispatch, getState) => {
    const immLiquidations = getState().liquidations;
    const isAlreadyFetching = immLiquidations.get('isFetchingPeriods');
    const hasError = immLiquidations.get('errorPeriods') !== '';

    if (!isAlreadyFetching && !hasError) {
        const immAccounts = getState().accounts;
        const immDeposits = getState().deposits;
        const immDeposit = immDeposits.getIn(['byId', depositId]);
        const immImposition = immDeposit.getIn(['impositionList','byId', impositionId]);
        const immImpositionAssociatedAccount = immDeposit.get('impositionAssociatedAccount');
        const immAssociatedAccount = getAccountByImposition(immImpositionAssociatedAccount, immAccounts);
        const contractNumber = immDeposit.getIn(['contract', 'contractNumber']);
        const product = immDeposit.getIn(['contract', 'product']);
        const currencyCode = immImposition.get('currency');
        const impositionNumber = immImposition.get('id');
        let accountNumber = '';
        let controlDigit = '';
        if (!!immAssociatedAccount) {
            accountNumber = `${immAssociatedAccount.get('product')}${immAssociatedAccount.get('contractNumber')}`;
            controlDigit = immAssociatedAccount.getIn(['ibanComplex', 'digitodecontrol']);
        }
        const requestData = {
            query: {
                digitoDeControl: controlDigit,
                moneda: currencyCode,
                numeroContrato: contractNumber,
                numeroDeCuenta: accountNumber,
                numeroImposicion: impositionNumber,
                producto: product
            }
        };

        dispatch(requestLiquidationsPeriodInProgress());

        return APIGet(dispatch, apiURLBuilder.getURL('requestLiquidationsPeriod'), requestData)
            .then(response => dispatch(requestLiquidationsPeriodSuccess(response)))
            .catch(error => dispatch(requestLiquidationsPeriodFailure(error)));
    }
};

const requestLiquidationsDetailsSuccess = (response, liquidationId) => ({
    type: actionTypes.FETCH_LIQUIDATIONS_DETAILS_SUCCESS,
    payload : {
        liquidationId,
        details: get(response, 'detalles', [])
    }
});

const requestLiquidationsDetailsFailure = (error) => ({
    type: actionTypes.FETCH_LIQUIDATIONS_DETAILS_FAILURE,
    payload : {
        error
    }
});

const requestLiquidationsDetailsCompleted = () => ({
    type: actionTypes.FETCH_LIQUIDATIONS_DETAILS_COMPLETED
});

const requestLiquidationsDetails = (depositId, impositionId) => (dispatch, getState) => {
    let promises = [];
    const immLiquidations = getState().liquidations;

    if (immLiquidations.get('byOrder').size) {
        const immDeposit = getState().deposits.getIn(['byId', depositId]);
        const immImposition = immDeposit.getIn(['impositionList','byId', impositionId]);
        const contractNumber = immDeposit.getIn(['contract', 'contractNumber']);
        const currencyCode = immImposition.get('currency');
        const product = immDeposit.getIn(['contract', 'product']);
        const subContractNumber = immImposition.get('id');

        immLiquidations.get('byOrder').forEach((liquidationId) => {
            const immLiquidation = immLiquidations.getIn(['byId', liquidationId]);
            const periodToDate = immLiquidation.get('periodToDate');
            const amount = immLiquidation.getIn(['payment', 'amount']);

            const requestData = {
                query: {
                    codigoMoneda: currencyCode,
                    fechaFinalPeriodoLiquidacion: periodToDate,
                    importe: amount,
                    numeroContrato: contractNumber,
                    numeroSubcontrato: subContractNumber,
                    producto: product,
                    divisa: currencyCode
                }
            };

            promises.push(
                APIGet(dispatch, apiURLBuilder.getURL('requestLiquidationsDetails'), requestData)
                    .then(response => dispatch(requestLiquidationsDetailsSuccess(response, liquidationId)))
                    .catch(error => dispatch(requestLiquidationsDetailsFailure(error)))
            );
        });

        Promise.all(promises).then(() => dispatch(requestLiquidationsDetailsCompleted()));
    } else {
        dispatch(requestLiquidationsDetailsCompleted());
    }
};

const requestLiquidationsInProgress = () => ({
    type: actionTypes.FETCH_LIQUIDATIONS_REQUEST
});

const requestLiquidationsSuccess = (response) => ({
    type: actionTypes.FETCH_LIQUIDATIONS_SUCCESS,
    payload : {
        liquidations: get(response, 'listaLiquidaciones.liquidacion', [])
    }
});

const requestLiquidationsFailure = (error) => ({
    type: actionTypes.FETCH_LIQUIDATIONS_FAILURE,
    payload : {
        error
    }
});

const requestLiquidations = (depositId, impositionId) => (dispatch, getState) => {
    const immLiquidations = getState().liquidations;
    const isAlreadyFetching = immLiquidations.get('isFetching');
    const hasError = immLiquidations.get('error') !== '';

    if (!isAlreadyFetching && !hasError) {
        const immDeposit = getState().deposits.getIn(['byId', depositId]);
        const immImposition = immDeposit.getIn(['impositionList','byId', impositionId]);
        const contractNumber = immDeposit.getIn(['contract', 'contractNumber']);
        const currencyCode = immImposition.get('currency');
        const fromDate = immImposition.get('activationDate');
        const product = immDeposit.getIn(['contract', 'product']);
        const subContractNumber = immImposition.get('id');
        const toDate = immImposition.get('expirationDate');

        const requestData = {
            query: {
                codigoMoneda: currencyCode,
                fechaDesde: fromDate,
                fechaHasta: toDate,
                numeroContrato: contractNumber,
                numeroSubContrato: subContractNumber,
                producto: product
            }
        };

        dispatch(requestLiquidationsInProgress());

        return APIGet(dispatch, apiURLBuilder.getURL('requestLiquidations'), requestData)
            .then(response => dispatch(requestLiquidationsSuccess(response)))
            .then(() => dispatch(requestLiquidationsDetails(depositId, impositionId)))
            .catch(error => dispatch(requestLiquidationsFailure(error)));
    }
};

const resetLiquidationsFailure = () => (dispatch) => {
    dispatch({
        type: actionTypes.RESET_LIQUIDATIONS_FAILURE
    });
};

module.exports = {
    requestLiquidations,
    requestLiquidationPeriods,
    resetLiquidationsFailure
};
